import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RetrieveStaticDocumentSets } from '@app/shared/services/retrieve-static-document-sets.service';
import { GenerateStaticDocumentSets } from '@app/shared/services/generate-static-document-sets.service';
import { DataGridConfig } from '@shared/components/data-grid/data-grid-config';
import { NotificationService } from '@app/shared/components/notification/notification.service';
import { GridRefreshService } from '@app/shared/services/grid-refresh.service';
import { Notification } from '@shared/components/notification/models/notification.model';

@Component({
  selector: 'db-generate-pdf-dialog.component',
  templateUrl: './generate-pdf-dialog.component.html',
  styleUrls: ['./generate-pdf-dialog.component.scss']
})
export class GeneratePDFDialogComponent implements OnInit {
  dataGridConfig: DataGridConfig;
  rowData: any[];
  selectedRowData: any[] = [];

  constructor(
    private retrieveStaticDocumentSets: RetrieveStaticDocumentSets,
    private generateStaticDocumentSets: GenerateStaticDocumentSets,
    private notificationService: NotificationService,
    private gridRefreshService: GridRefreshService,
    public generatePDFDialogRef: MatDialogRef<GeneratePDFDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.configureGrid();
    this.initializeRowData();
  }

  configureGrid() {
    this.dataGridConfig = {
      columnDefs: [
        {
          headerName: 'Document Set',
          field: 'name',
          minWidth: 200
        }
      ],
      defaultColDef: {
        headerCheckboxSelection: this.isFirstColumn,
        checkboxSelection: this.isFirstColumn
      },
      rowSelection: 'multiple'
    };
  }

  isFirstColumn(params) {
    const displayedColumns = params.columnApi.getAllDisplayedColumns();
    const thisIsFirstColumn = displayedColumns[0] === params.column;
    
    return thisIsFirstColumn;
  }

  initializeRowData() {
    this.retrieveStaticDocumentSets.getAllStaticDocumentSets().subscribe({
      next: (result: any[]) => {
        this.rowData = result.map((item, idx) => ({
          ...item,
          name: item
        }));
      },
      error: () => {
        this.notificationService.notification(
          new Notification(
            'danger', 'Static Documents', 'Failed to get Static Documents.'
          )
        )
      }
    });
  }

  selectedRows($event) {
    this.selectedRowData = $event.map((x: any) => x.name);
  }

  generatePDFS() {
    this.generateStaticDocumentSets.generateStaticDocs(this.data.client.clientId, this.data.answerSetId, this.selectedRowData).subscribe({
      next: () => {
        this.gridRefreshService.refreshGridData();
        this.generatePDFDialogRef.close();

        this.notificationService.notification(
          new Notification(
            'success', 'Static Documents', 'Documents have been successfully generated.'
          )
        )
      },
      error: () => {
        this.notificationService.notification(
          new Notification(
            'danger', 'Static Documents', 'Failed to get generate Static Documents.'
          )
        )
      }
    })
  }
}
